export default __webpack_public_path__ + "/assets/images/nia_logo.png";